import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FileText, Search, ChevronDown } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '../../ui/popover';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export const useReplyTemplates = (token, enabled = true) => {
  const [templates, setTemplates] = useState([]);
  const reload = () => axios.get(`${API_URL}/admin/reply-templates`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => setTemplates(r.data)).catch(() => {});
  useEffect(() => { if (enabled && token) reload(); }, [token, enabled]); // eslint-disable-line react-hooks/exhaustive-deps
  return [templates, setTemplates, reload];
};

export const TemplatePicker = ({ templates, onPick, compact }) => {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState('');
  const active = templates.filter((t) => t.active !== false);
  const list = active.filter((t) => !q || [t.name, t.category, t.subject].some((v) => v?.toLowerCase().includes(q.toLowerCase())));
  const groups = list.reduce((acc, t) => { (acc[t.category || 'General'] ||= []).push(t); return acc; }, {});
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" className="inline-flex items-center gap-1.5 h-7 px-2 rounded-md text-xs text-neutral-700 hover:bg-neutral-100 border border-transparent hover:border-neutral-200" data-testid="template-picker-btn" title="Insert a saved reply">
          <FileText className="w-3.5 h-3.5 text-amber-600" />{compact ? null : 'Templates'}<ChevronDown className="w-3 h-3 opacity-60" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-80 p-0 z-[80]" data-testid="template-picker">
        <div className="p-2 border-b border-neutral-100 relative">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-neutral-400" />
          <input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search templates…" className="w-full h-8 pl-8 pr-2 rounded-md bg-neutral-100 text-xs outline-none focus:bg-white focus:ring-1 focus:ring-amber-400" data-testid="template-picker-search" />
        </div>
        <div className="max-h-72 overflow-y-auto py-1">
          {list.length === 0 && <p className="px-3 py-6 text-center text-xs text-neutral-500">No templates yet. Create them under Emails → Templates.</p>}
          {Object.entries(groups).map(([cat, items]) => (
            <div key={cat}>
              <p className="px-3 pt-2 pb-1 text-[10px] font-semibold uppercase tracking-wider text-neutral-400">{cat}</p>
              {items.map((t) => (
                <button key={t.id} type="button" onClick={() => { onPick(t); setOpen(false); setQ(''); }} className="w-full text-left px-3 py-1.5 hover:bg-amber-50" data-testid={`template-option-${t.id}`}>
                  <p className="text-xs font-medium text-neutral-900">{t.name}</p>
                  <p className="text-[11px] text-neutral-500 truncate">{t.subject}</p>
                </button>
              ))}
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default TemplatePicker;
